// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a788cd1","396":"15d4825e","451":"64f1e6bd","455":"2793e780","977":"e26e1a45"}[chunkId] + ".chunk.js";
};